import { useAuth } from './useAuth'

export function LoginScreen() {
  const { login, error, status } = useAuth()

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.logo}>⬡</div>
        <h1 style={styles.title}>Animus Arena</h1>
        <p style={styles.subtitle}>FPV observer for the workflow floor</p>

        {error && <p style={styles.error}>{error}</p>}

        <button
          style={styles.button}
          onClick={login}
          disabled={status === 'loading'}
        >
          {status === 'loading' ? 'Connecting…' : 'Sign in with Portal'}
        </button>

        <p style={styles.hint}>
          Sign in through Arena to access your authorized workspace.
        </p>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(ellipse at center, #0f172a 0%, #020617 100%)',
    zIndex: 100,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    padding: '2.5rem 3rem',
    background: 'rgba(15,23,42,0.8)',
    border: '1px solid rgba(99,102,241,0.3)',
    borderRadius: '1rem',
    backdropFilter: 'blur(12px)',
    boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
    maxWidth: '22rem',
    width: '100%',
    textAlign: 'center',
  },
  logo: {
    fontSize: '3rem',
    color: '#818cf8',
    lineHeight: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#f1f5f9',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '0.875rem',
    color: '#94a3b8',
  },
  error: {
    padding: '0.5rem 0.75rem',
    background: 'rgba(239,68,68,0.15)',
    border: '1px solid rgba(239,68,68,0.4)',
    borderRadius: '0.375rem',
    color: '#fca5a5',
    fontSize: '0.813rem',
    width: '100%',
  },
  button: {
    width: '100%',
    padding: '0.75rem 1.5rem',
    background: '#4f46e5',
    border: 'none',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.938rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s',
  },
  hint: {
    fontSize: '0.75rem',
    color: '#64748b',
  },
}
